import { Component, OnInit, ViewChild } from '@angular/core';
import { Folder } from 'src/app/models/folder.model';
import { MediaObserver } from '@angular/flex-layout';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _ from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { first, firstValueFrom } from 'rxjs';
import * as globals from '../../globals';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { LoggingService } from '../../../services/logging.service';
import { ConnectService } from 'src/app/services/connect.service';

@Component({
  standalone: false,
  selector: 'app-folders-list',
  templateUrl: './folders-list.component.html',
  styleUrls: ['./folders-list.component.scss'],
})

export class FoldersListComponent implements OnInit {

  constructor(
    public media: MediaObserver,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private connectService: ConnectService,
    private logger: LoggingService) { }

  ngOnInit(): void {
    // this.isContributor = ([`${globals.TC}:${globals.trainingadmin}`, `${globals.TC}:${globals.trainer}`].includes(localStorage.getItem(globals.POLICIES)));
    this.retrieveFolders();
  }

  private retrieveFolders(refresh: boolean = false) {
    try {
      this.loadingSpinner(true);
            
      if (refresh) {
        this.showMessage(globals.hardRefresh_folders);
      }

      this.connectService.getActiveFolders(refresh).subscribe({
        next: (data) => {
          const selectionFolders = this.selection.selected.map(folder => folder.asset_id);
          this.clearCheckBoxSelection();

          data.forEach(folder => {
            const services = folder.services.map(service => `${service.name}-${service.status}`).join(', ');
            folder.services_data = services;
          });

          this.dataSource = new MatTableDataSource(data);
          this.foldersLength = data.length;

          data.forEach(folder => selectionFolders.includes(folder.asset_id) ? this.selection.select(folder) : null);
          this.loadingSpinner(false);
        },
        error: (e) => {
          this.logger.logException(e);
          this.loadingSpinner(false);
        }
      });
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner(false);
    }
  }

  refreshFolders = () => this.retrieveFolders(true);

  isMobile = () => window.matchMedia('(max-width: 840px)').matches;

  public async cleanupFolders() {
    try {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          dialogTitle: 'Delete Active Folders',
          description: `${globals.cleanupFolders}, ${globals.DELETE_WARN}?`,
          cautionaryMessage: '',
          okButtonTitle: globals.DELETE,
        },
        width: '500px'
      });

      const result = await firstValueFrom(dialogRef
        .afterClosed()
        .pipe(first()));

      if (result) {
        this.loadingSpinner(true);
        const selectedFolders = this.getSelectedFolders();

        const groupedFolders = Object.values(
          selectedFolders.reduce((acc, folder) => {
            if (!acc[folder.account_id]) {
              acc[folder.account_id] = { account_id: folder.account_id, asset_ids: [] };
            }
            acc[folder.account_id].asset_ids.push(`${folder.asset_id}|${folder.asset_name}`);
            return acc;
          }, {} as Record<string, { account_id: string; asset_ids: string[] }>)
        );

        this.showMessage(globals.cleanupFolders);
        await firstValueFrom(this.connectService.cleanupActiveFolders(groupedFolders));
        this.loadingSpinner(false);
      }
      else {
        this.loadingSpinner(false);
      }
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner(false);
    }
  }

  private async assignResources(folders: any) {
    this.showMessage(globals.assignProcess_time);
    try {
      await firstValueFrom(this.connectService.assignResources(folders));
      setTimeout(() => this.loadingSpinner(false), (10 * 1000));
      setTimeout(() => this.retrieveFolders(false), 6000);
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner(false);
    }
  }

  private clearCheckBoxSelection = () => (this.selection.clear());

  /** Whether the number of selected elements matches the total number of rows. */
  private isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  private masterToggle = () => {
    this.isAllSelected() ? 
      this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  };

  private getSelectedFolders = () => {
    const selectedFolders = this.selection.selected.filter(folder => !this.isCheckBoxView(folder));
    return selectedFolders;
  };

  public isActiveFoldersViews = () => {
    const selectedStudents = this.getSelectedFolders();
    return (selectedStudents.length >=1);
  };

  private isCheckBoxView = (row: Folder) => this.isView(row);

  private isView = (folder: Folder) => (false);

  loadingSpinner = (value: boolean) => this.isLoading = value;

  private showMessage = (message: string) => this.snackBar.open(message, null, { duration: 5000 });

  // Define variables and objects
  isLoading: boolean;
  hasBackdrop: boolean;
  isContributor: boolean;
  currentIndex = -1;
  foldersLength = 0;
  selection = new SelectionModel<Folder>(true, []);
  displayedColumns: string[] = globals.folderList_columns;
  dataSource = new MatTableDataSource<Folder>();

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }
}
